// ***********************************
// BatchDefine.vue
// ***********************************
<template>
  <div id="app">
    <div class="container">
      <div>
        <router-link :to="{ name: 'BatchHome'}">List</router-link> | 
        <router-link :to="{ name: 'BatchAdd'}">Add</router-link> |
        <router-link :to="{ name: 'Profile' }">Share</router-link> 
      </div>
      <br/>
      <b-alert :show="showAlert" :variant="alertStyle">{{alertText}}
        <div v-show="showAlert && alertStyle=='success'">
          <router-link :to="{ name: 'BatchHome' }">Click here to continue</router-link>
        </div>
      </b-alert>
      <b-card v-if="!showAlert" header="Create a new batch from your already uploaded databases">
        <b-list-group>






          <b-form @submit="onSubmit" @reset="onReset" v-if="show">

          <b-list-group-item>
            <div>
              <b>Use the checkboxes to select the databases you want to include in the batch</b>
              <b-card bg-variant="light" class="text-left">
                  
                  <div id="demo">
                    
                    <b-pagination
                      :total-rows="collection_list.length"
                      :per-page="perPage"
                      v-model="currentInputPage"
                      size="sm"
                      align="center"
                    />
                    <b-table
                      :per-page="perPage"
                      :current-page="currentInputPage"
                      striped
                      hover
                      responsive
                      bordered
                      :items="collection_list"
                      :fields="inputFields"
                      :sort-by.sync="inputSortBy"
                      class="table table-sm"
                    >
                      <template v-slot:cell(collection_id)="row">
                        <b-form-checkbox
                          v-model="row.item.include"
                          value="Y"
                          unchecked-value="N"
                          size="sm"
                        >
                        </b-form-checkbox>
                      </template>
                      
    
                      <template #cell(db_name)="row">
                        <a :href="`/metrics/${row.item.collection_id}/ora_v1`" target="_blank">{{ row.item.db_name }}</a>
                      </template>
                      <!--<template #cell(db_name)="row">-->
                      <!--  <a v-b-tooltip.hover :title="`${row.item.descr}`" :href="`/metrics/${row.item.collection_id}/ora_v1`" target="_blank">{{ row.item.db_name }}</a>-->
                      <!--</template>-->

                    </b-table>
    
                    <br/><br/><br/>
                  </div>
    


              </b-card>
            </div>
          </b-list-group-item>




          <b-list-group-item>
            <div>
              <b>Provide some details about this batch.</b>
              <b-card bg-variant="light" class="text-left">

                  <b-form-group id="exampleInputGroup2" label="Customer Name:" label-for="customer">
                    <b-form-input
                      id="customer"
                      type="text"
                      v-model="form.customer"
                      required
                      placeholder="Enter customer name."
                      list="my-list-id">
                    </b-form-input>
                    <datalist id="my-list-id">
                      <option v-for="(item, index) in this.CustomerChoices" :key="index">{{ item.value }}</option>
                    </datalist>
                  </b-form-group>

                  <b-form-group id="exampleInputGroup3" label="Batch Name:" label-for="batchname">
                    <b-form-input
                      id="batchname"
                      type="text"
                      v-model="form.batchname"
                      required
                      placeholder="Enter batch name."
                    ></b-form-input>
                  </b-form-group>

                 <b-form-group id="exampleInputGroup4" label="Description:" label-for="descr">
                    <b-form-textarea
                      id="descr"
                      v-model="form.descr"
                      required
                      placeholder="Enter a description for this batch of databases."
                      :rows="3"
                      :max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
            
              </b-card>
            </div>
          </b-list-group-item>



          <b-list-group-item>
            <div>
              <b>Save your new batch definition</b>
              <b-card bg-variant="light" class="text-left">
                <div class="text-center">
                  <b-button type="submit" :disabled="showFileAlert" variant="primary">Save</b-button>
                  <!--<b-button type="reset" variant="danger">Reset</b-button>-->
                </div>
              </b-card>
            </div>
          </b-list-group-item>
          </b-form>      
        </b-list-group>
      </b-card>
    </div>
  </div>
</template>    


<script>
import { API, Storage } from "aws-amplify";
export default {
  name: "app",
  props: ["user"],
  data() {
    return {
      selected: null,
      output_file: null,
      collection_list: [
        {
          collection_id: "0",
          descr: "Please wait while we load data..."
          // db_type: "Oracle",
          // collection_type: "ora_v1",
          // status: "processed",
          // descr: "another collection example",
          // collection_date: "2018-12-14 15:00:19",
          // customer: "Octank Gaming"
        }
      ],
      inputSortBy: "row",
      currentInputPage: 1,
      inputFields: [
        {collection_id: {
          label: "Include?",
          sortable: true
        }},
        {customer: {
          label: "Customer",
          sortable: true
        }},
         {db_name: {
          label: "Database",
          sortable: true
        }},
        {descr: {
          label: "Description",
          sortable: true
        }},
        {platform_name: {
          label: "Platform",
          sortable: true
        }},
        {version: {
          label: "Version",
          sortable: true
        }},
       {total_size: {
          label: "Size",
          sortable: true
        }}
      ],

      perPage: 15,
      form: {
        customer: "",
        batchname: "",
        descr: ""
      },
      show: true,
      showAlert: false,
      showFileAlert: false,
      isUploading: false,
      alertText: "",
      alertStyle: "default",
      alertFileText: "",
      CustomerChoices: [
          { value: 'Customer1', text: 'Customer1' },
      ]
    };
  },
  async created() {
    // console.log("Add: I am here1");
    var tries = 2;
    while (tries > 0) {
      await API.get("dbcsiAPI", `/dbcsi/customers`)
        .then(response => {
          // console.log("Add: I am here3");
          //use .shift() to remove the first row
          var filteredItems = response.data.filter(item => item.value !== 'xxALL');
          this.CustomerChoices = filteredItems;
          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Add Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });

      tries -= 1;
    }
    
    await API.get("dbcsiAPI", `/dbcsi/collections`)
      .then(response => {
        // console.log("Main: I am here3");
        this.collection_list = response.data;
        // console.log(this.genItems);
      })
      .catch(error => {
        console.log("BatchDefine Error:", error);
      });

  },
  
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    });
  },

  beforeRouteLeave (to, from , next) {
    if (this.isUploading) {
      if (!window.confirm("Do you really want to leave? The upload is not finished yet and you will lose it!")) {
        console.log("BatchAdd: Not OK to Leave");
        return;
      }
    }
    next();
  },
  
  methods: {
    preventNav(event) {
      if (!this.isUploading) return;
      console.log("BatchAdd: preventNav: Not OK to Leave");
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = "";
    },


    async onSubmit(evt) {
      evt.preventDefault();
      let collection_type = "ora_v1";
      
      this.alertStyle="primary"
      this.alertText = "Saving batch definition to database... Please wait... Do not leave this page yet.";
      this.showAlert = true;
      this.isUploading = true;
      
      var tries = 3;
      var success = true;
      if (success) {
        // console.log("BatchDefine: I am here4");
        
        // get an array of just the collection_ids that are checked.
        
        var selected_ids = [];
        for (var i of this.collection_list) {
          if (i.include == "Y") {
            selected_ids.push({collection_id: i.collection_id});
          }  
        }  
        console.log(selected_ids);
        
        //do a put to /collections
        const putParams = {
          body: {
            db_type: "Oracle",
            customer: this.form.customer,
            batchname: this.form.batchname,
            descr: this.form.descr,
            collection_type: collection_type,
            collection_ids: selected_ids
          }
        };

        var new_id = null;
        var api_success = false;
        await API.put("dbcsiAPI", `/dbcsi/batch`, putParams)
          .then(response => {
            new_id = response.data.batch_id;
            api_success = true;
            console.log("BatchDefine API.put: new batch_id=", new_id);
            this.alertText = "Batch defined successfully.";
            this.alertStyle="success";
            this.isUploading = false;

          })
          .catch(error => {
            console.log("BatchDefine API.put Error:", error);
            // alert("API.put error");
              this.alertText = "Database put error.";
              this.alertStyle="danger";
              this.isUploading = false;
          });

      }

      //   alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.customer = "";
      this.form.descr = "";
      this.output_file = null;
      this.$refs.fileinput.reset();
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }

  }
};
</script>

<style>
</style>
